import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

let players = [];

export function contentsYoutubeSlider() {
  const youtube_slider = document.querySelector("#top_contents_youtube_slider");
  if(!youtube_slider) return;

  const movies = document.querySelectorAll(".top_contents_youtube_player");

  // 再生
  const thumbs = document.querySelectorAll('.top_contents_youtube_thumbnail');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', function(){
      thumb.classList.add('is-playing');
      let moviewindow = thumb.nextElementSibling.contentWindow;
      moviewindow.postMessage('{"event":"command", "func":"playVideo", "args": null}', '*');
    });
  });


  const swiper = new Swiper('#top_contents_youtube_slider', {
    loop: false,
    slidesPerView: 1,
    speed: 400,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.top_contents_youtube-next',
      prevEl: '.top_contents_youtube-prev',
    },
    keyboard: {
      enabled: true,
    },
    a11y: {
      containerMessage:'YouTube 動画表示エリアです',
      prevSlideMessage: '前の動画へ',
      nextSlideMessage: '次の動画へ',
      slideLabelMessage:'{{index}}本目の動画を表示',
      paginationBulletMessage: '{{index}}本目の動画を表示',
    },

    on: {
      slideChange: () => { //スライドが切り替わったら前の動画は一時停止
        let previousMovie = movies[swiper.previousIndex].contentWindow;
        previousMovie.postMessage('{"event":"command", "func":"pauseVideo", "args": null}', '*');
      }
    }
  });
}
